<template>

    <CardShell class="flex items-center justify around" :style="'height:' + height + 'px'">
        <div class="relative h-inherit">
            <img class="absolute w-third" src='@/assets/img/button_change_photo.svg'/>
            <img class="h-inherit" :style="'width' + height + 'px'" :src="avatar"/>
        </div>
        <div class="pl3">
            <h5>{{user.name}}</h5>
            
            <div  v-if="isDashboard">
                <router-link class="link formLabel yellow" :to="getRoute">    
                    <div class="label grow">Go to Account Settings</div>
                </router-link>
            </div>
            <div v-else class="label">{{user.email}}</div>
        </div>
    </CardShell>

</template>

<script>
import CardShell from '@/components/global/CardShell.vue';

export default {
    data() {
        return {
            avatar: require(`@/assets/img/avatars/avatar_1.svg`)
        };
    },
    props: {
        user: {
            type: Object,
            required: true
        },
        height: {
            type: String,
            required: true
        },
        isDashboard: {
            type: Boolean,
            default: false
        }
    },
    components: {
        CardShell
    },
    methods: {
        smallOrLess() {
            return this.$mq === 'xs' || this.$mq === 'sm';
        }
    },
    computed: {
        getRoute() {
            return this.smallOrLess() ? '/settings-mobile' : '/account-info';
        }
    }
};
</script>
